import React, { useEffect, useState } from "react";
import { styled } from "../../stitches.config";
import Title from "../atoms/Title";
import Breadcrumbs from "../components/Breadcrumbs";
import { h3, bodyLarge } from "../commonStyles/Fonts";
import Link from "../../components/Link";
import Media from "../../components/common/Media";
import Footer from "../components/Footer"


interface IAuthors {
    img: string;
    name: string,
    profession: string,
    url: string,
    isRecentlyActive: boolean,
}
const AuthorsPage = () => {
    const [authors, setAuthors] = useState<IAuthors[]>([]);

    useEffect(() => {
        const fetchUrl = `${window.API_HOST}/pwa-redakcja/`;

        fetch(fetchUrl)
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response.status);
            })
            .then((response) => {
                setAuthors(response.authors);
            });
    }, []);

    return (
        <>
            <Background>
                <Container>
                    <Breadcrumbs category={{ name: "Skład redakcji", link: "/redakcja" }} allWhite />
                    <Title withDots size="large" type="black">
                        Skład redakcji
                    </Title>
                    <ContentWrapper className='authors__container'>
                        {authors.map((author, i) => {
                            return (
                                <>
                                    {
                                        author.isRecentlyActive ?
                                            <Link to={author.url}>
                                                <AuthorsWrapper className="authors__box">
                                                    <AuthorsImage>
                                                        <Media src={author.img} />
                                                    </AuthorsImage>
                                                    <AuthorsInfo>
                                                        <h3 className={h3()}>
                                                            {author.name}
                                                        </h3>
                                                        <AuthorsPosition className={bodyLarge()}>
                                                            {author.profession}
                                                        </AuthorsPosition>
                                                    </AuthorsInfo>
                                                </AuthorsWrapper>
                                            </Link>
                                            :
                                            <AuthorsWrapper>
                                                <AuthorsImage>
                                                    <Media src={author.img} />
                                                </AuthorsImage>
                                                <AuthorsInfo>
                                                    <h3 className={h3()}>
                                                        {author.name}
                                                    </h3>
                                                    <AuthorsPosition className={bodyLarge()}>
                                                        {author.profession}
                                                    </AuthorsPosition>
                                                </AuthorsInfo>
                                            </AuthorsWrapper>
                                    }
                                </>
                            )
                        })}
                    </ContentWrapper>
                </Container>
            </Background>
            <Footer />
        </>
    )
}


const Background = styled("div", {
    backgroundColor: "$grayscale100Fixed",
    padding: "41px 0 78px 0",
    width: "100%",
    "& .title": {
        color: "$grayscale0Fixed !important",
        background: "$grayscale100Fixed !important"
    }
});
const Container = styled("div", {
    margin: "0 auto",
    padding: "0 16px",
    "@bp3": {
        padding: "0 84px",
    },
});
const ContentWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: "24px",
    "& a": {
        textDecoration: "none",
        "&:hover, &:active": {
            color: "$grayscale0Fixed",
            textDecoration: "none",
        },
    },

    ".authors__box": {
        "&:hover": {
            backgroundColor: "$grayscale0Fixed",
            "h3": {
                color: "$grayscale100Fixed",
                textDecoration: "none",
            },
        },
    },

    "@bp4": {
        flexWrap: "wrap",
        flexDirection: "row",
        gap: "40px 20px",
    },
});
const AuthorsWrapper = styled("div", {
    backgroundColor: "$grayscale100Fixed",
    border: "1px solid grey",
    width: "330px",
    transition: "0.3s",

    "@bp3": {
        width: "302px",
    },
});
const AuthorsImage = styled("div", {
    height: "328px",
    width: "328px",
    "& img": {
        height: "100%",
        width: "100%",
        objectFit: "cover",
    },
    "@bp3": {
        height: "300px",
        width: "300px",
        "& img": {
            height: "100%",
            width: "100%",
            objectFit: "cover",
        },
    },
});
const AuthorsInfo = styled("div", {
    height: "110px",
    padding: "24px 24px 56px 24px",
    width: "328px",
    "@bp3": {
        width: "302px",
    },
    "h3": {
        marginBottom: "4px",
        marginTop: "0",
        color: "$grayscale0Fixed",
        textDecoration: "none"
    },
});
const AuthorsPosition = styled("div", {
    color: "$grayscale75",
    textDecoration: "none"
});

export default AuthorsPage;